const ROUTE_LOGIN: string = "login";
const ROUTE_LOGIN_METHOD: string = "method";
const ROUTE_VERIFICATION = "verification";
const ROUTE_VERIFICATION_MPIN: string = "mpin";
const ROUTE_VERIFICATION_OTP: string = "otp";

const PUBLIC_ROUTER = {
  ROOT: {
    path: "/",
  },
  LOGIN: {
    path: "/login",
  },
  LOGIN_MPIN: {
    path: "/verification/mpin",
  },
  LOGIN_OTP: {
    path: "/verification/otp",
  },
  PIN_MY_LOCATION: {
    path: "/pin_my_location",
  },
  SIGNUP: {
    path: "/signup",
  },
  SIGNUP_OTP: {
    path: "/signup/verification/otp",
  },
  STORE_FORMAT_DISPLAY: {
    path: "/storeFormatDisplay",
  },
  UNSERVICABLE: {
    path: "/unservicable",
  },
  DELIVERY_ADDRESS: {
    path: "/deliveryAddress",
  },
  SET_STORE_PROFILE: {
    path: "/setStoreProfile",
  },
  PIN_MY_LOCATION_CONFIRMATION: {
    path: "/pin_my_location_confirmation",
  },
  INFORMATIONAL: {
    path: "/informational",
  },
  INFORMATIONAL_THANKS: {
    path: "/informational_thanks",
  },
  PUBLIC_PRODUCTS_LIST: {
    path: "/pre-signup-pricelist",
  },
  LINK_FBM: {
    path: "/link-fbm",
  },
};

const WELCOME_PRIVATE_ROUTER = {
  STORE_DETAILS: {
    path: "/store-details-confirm",
  },
  SECURITY_QUESTIONS: {
    path: "/security-questions",
  },
  WELCOME_PAGE1: {
    path: "/welcome-page1",
  },
  WELCOME_PAGE2: {
    path: "/welcome-page2",
  },
};

const AUTHORIZED_ROUTER = {
  MERCHANT_SELECTION: {
    path: "/merchants",
  },
  HOME: {
    path: "/home",
  },
  INBOX: {
    path: "/inbox",
  },
  MESSAGE: {
    path: "/inbox/:message_id",
  },
  ACTIVITY: {
    path: "/activity",
  },
  ACTIVITY_DETAILS: {
    path: "/activity/:identifier",
    dynamicPaths: {
      identifier: `:identifier`,
    },
  },
  ACCOUNT: {
    path: "/account",
  },
  ACCOUNT_DETAILS: {
    path: "/account/details",
  },
  CONTACT_US: {
    path: "/account/contact-us",
  },
  WALLET: {
    path: "/account/wallet",
  },
  PRODUCT_CATALOG: {
    path: "/products",
  },
  PRODUCT_SEARCH: {
    path: "/products/search",
  },
  CARTS: {
    path: "/carts",
  },
  EDIT_CART: {
    path: "/cart/edit",
  },
  CART_CONFIRMATION: {
    path: "/cart/confirmation",
  },
  activities: {
    path: "/activities",
  },
  CHECKOUT_DELIVERY_DATES: {
    path: "/checkout/delivery_dates",
  },
  CHECKOUT_PAYMENT_METHODS: {
    path: "/checkout/payment_methods",
  },
  CHECKOUT_PLACE_ORDER: {
    path: "/checkout/place_order",
  },
  CHECKOUT_PAYMENT_DEDUCTION: {
    path: "/checkout/payment_deduction",
  },
  CHECKOUT_PLACE_ORDER_STATUS: {
    path: "/checkout/place_order_status",
  },
  SUPER_DEALS: {
    path: "/super_deals",
  },
  VOUCHER_DETAILS_PAGE: {
    path: "/super_deals/details",
  },
  NEAREST_VOUCHER_PAGE: {
    path: "/cart/nearest/voucher",
  },
  SELECT_VOUCHER_PAGE: {
    path: "/cart/select/voucher",
  },
  COMPLETE_STORE_PROFILE: {
    path: "/complete_store_profile",
  },
  COMPLETE_STORE_PROFILE_PIN_LOCATION: {
    path: "/complete_store_profile_pin_location",
  },
  COMPLETE_STORE_PROFILE_STORE_PHOTO: {
    path: "/complete_store_profile_store_photo",
  },
  COMPLETE_STORE_PROFILE_ADDRESS: {
    path: "/complete_store_address",
  },
};

const FMB_ROUTER = {
  LINK_FBM_STATUS: {
    path: "/link-fbm-status",
  },
};

export {
  ROUTE_LOGIN,
  ROUTE_LOGIN_METHOD,
  ROUTE_VERIFICATION,
  ROUTE_VERIFICATION_MPIN,
  ROUTE_VERIFICATION_OTP,
  PUBLIC_ROUTER,
  AUTHORIZED_ROUTER,
  WELCOME_PRIVATE_ROUTER,
  FMB_ROUTER,
};
